import { useIntl } from 'react-intl';
import { StyledPublicationPeriod, ProgressBarFill } from './style';
import dayjs from 'dayjs';

interface ListingPublicationPeriodProps {
  publicationStartDate: string;
  publicationEndDate: string;
  showLabel?: boolean;
}

const calculateTimeProgress = (startDate: string, endDate: string) => {
  const start = dayjs(startDate).valueOf();
  const end = dayjs(endDate).valueOf();
  const now = dayjs().valueOf();

  if (now < start) return 0;
  if (now > end) return 100;

  const total = end - start;
  const elapsed = now - start;
  return (elapsed / total) * 100;
};

export const ListingPublicationPeriod = ({
  publicationStartDate,
  publicationEndDate,
  showLabel = true,
}: ListingPublicationPeriodProps) => {
  const intl = useIntl();

  const timeProgress = calculateTimeProgress(publicationStartDate, publicationEndDate);

  return (
    <StyledPublicationPeriod className="publication-dates-row">
      {showLabel && (
        <span className="dates-label">
          {intl.formatMessage({ id: 'listing.publication_period' })}:
        </span>
      )}
      <div className="dates-content">
        <span className="date-start">
          {dayjs(publicationStartDate).format('DD.MM.YYYY')}
        </span>
        <div className="progress-bar-container">
          <div className="progress-bar-background">
            <ProgressBarFill $width={timeProgress} />
          </div>
        </div>
        <div className="date-row">
          <span className="date-label">
            {intl.formatMessage({ id: 'listing.publication_end' })}:
          </span>
          <span className="date-value">
            {dayjs(publicationEndDate).format('DD.MM.YYYY')}
          </span>
        </div>
      </div>
    </StyledPublicationPeriod>
  );
};